import { postRequest, getRequest } from '.';

export const getStations = async () => getRequest('stations');
export const validateUser = async (email: string, stationId: string) =>
  postRequest('authenticate-user', { email, station_id: stationId });
